module.exports = __webpack_public_path__ + "img/photoshop.663c9e0d.svg";